import React from 'react';
import MDialog from '@/components/ui/atoms/MDialog';

type DeleteAccountDialogType =
  | 'delete'
  | 'remove'
  | 'exit'
  | 'fm-delete'
  | 'fm-exit'
  | 'delete-other'
  | 'fo-delete-registered';

interface DeleteAccountDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: DeleteAccountDialogType;
  familyName?: string;
}

const DIALOG_TEXTS = {
  'delete-other': { 
    title: 'Delete this account?',
    description:
      'This action is permanent. This member’s profile will be deleted from Maatra.',
    confirm: 'Yes',
  },
  'delete': {
    title: 'Delete your account?',
    description:
      'Your account will be permanently deleted. Information added for members who do not have their own Maatra account will also be removed.',
    confirm: 'Yes',
  },
  remove: {
    title: 'Remove this member?',
    description:
      'This action is permanent. This member will no longer be part of your Maatra family.',
    confirm: 'Yes',
  },
  'exit': {
    title: 'Leave your Family?',
    description: 'You’ll lose access to shared family records and profiles. Your own health records will remain with you.',
    confirm: 'Yes',
  },
  'fm-delete': {
    title: 'Delete your account?',
    description: 'This action is permanent. Your profile and health records will be deleted.',
    confirm: 'Yes',
  },
  'fo-delete-registered': {
    title: 'Delete your account?',
    description:
      'This action is permanent. Your profile and health records will be deleted.',
    confirm: 'Yes',
  },
  'fm-exit': {
    title: (familyName?: string) => `Leave ${familyName || 'your family'}?`,
    description: 'You’ll lose access to shared family records and profiles. Your own health records will remain with you.',
    confirm: 'Yes',
  },
};

const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  type,
  familyName,
}) => {
  let title: string;
  let description: string;
  let confirm: string;
  if (type === 'fm-exit') {
    title = typeof DIALOG_TEXTS['fm-exit'].title === 'function' ? DIALOG_TEXTS['fm-exit'].title(familyName) : DIALOG_TEXTS['fm-exit'].title;
    description = DIALOG_TEXTS['fm-exit'].description;
    confirm = DIALOG_TEXTS['fm-exit'].confirm;
  } else {
    // @ts-ignore
    ({ title, description, confirm } = DIALOG_TEXTS[type]);
  }
  return (
    <MDialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      primaryCtaText={confirm}
      onPrimaryCta={onConfirm}
      secondaryCtaText="No"
      onSecondaryCta={onClose}
    />
  );
};

export default DeleteAccountDialog;
